import fetch from './fetch';
import { IRegisterRequestPayload, RegisterApiResponse } from './register.types';

export const register = (payload: IRegisterRequestPayload): RegisterApiResponse => {
  return fetch('POST', '/signup', payload);
};
